import React, { useState, useEffect } from "react";
import api from "../../api/axiosClient";

/* ─── Shared design tokens (match the dashboard theme) ─── */
const S = `
  .sp * { box-sizing: border-box; }

  .sp-tabs { display: flex; gap: 4px; margin-bottom: 1.5rem; background: #111114; border: 1px solid rgba(255,255,255,.06); border-radius: 12px; padding: 4px; }
  .sp-tab { flex: 1; padding: .55rem 1rem; background: none; border: none; border-radius: 9px; font-family: 'DM Sans', sans-serif; font-size: .82rem; font-weight: 600; color: #666; cursor: pointer; transition: all .15s; }
  .sp-tab.on { background: rgba(255,215,0,.1); color: #FFD700; }

  .sp-section-title { font-family: 'Playfair Display', serif; font-size: 1rem; font-weight: 800; color: #ECECEC; margin-bottom: 1rem; }

  .sp-card { background: #111114; border: 1px solid rgba(255,255,255,.06); border-radius: 16px; padding: 1.375rem; margin-bottom: 1rem; }

  .sp-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 1rem; }

  .sp-field { display: flex; flex-direction: column; gap: 5px; }
  .sp-label { font-size: .68rem; font-weight: 700; text-transform: uppercase; letter-spacing: .08em; color: #555560; }
  .sp-input { background: #0c0c0e; border: 1.5px solid rgba(255,255,255,.08); border-radius: 9px; padding: .65rem 1rem; color: #ECECEC; font-family: 'DM Sans', sans-serif; font-size: .88rem; outline: none; transition: border-color .2s; }
  .sp-input:focus { border-color: #FFD700; }
  .sp-input[type=number] { -moz-appearance: textfield; }

  .sp-save-row { display: flex; justify-content: flex-end; margin-top: 1.25rem; }
  .sp-btn-save { display: inline-flex; align-items: center; gap: 7px; background: linear-gradient(135deg, #FFD700, #F59E0B); color: #000; border: none; border-radius: 9px; padding: .65rem 1.5rem; font-family: 'DM Sans', sans-serif; font-size: .86rem; font-weight: 700; cursor: pointer; transition: all .2s; box-shadow: 0 3px 14px rgba(255,215,0,.22); }
  .sp-btn-save:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 6px 22px rgba(255,215,0,.36); }
  .sp-btn-save:disabled { opacity: .55; cursor: not-allowed; transform: none; }

  .sp-toast { padding: .7rem 1rem; border-radius: 10px; font-size: .82rem; font-weight: 600; margin-bottom: 1rem; }
  .sp-toast.ok  { background: rgba(34,197,94,.1); border: 1px solid rgba(34,197,94,.25); color: #4ade80; }
  .sp-toast.err { background: rgba(239,68,68,.1); border: 1px solid rgba(239,68,68,.25); color: #f87171; }

  /* ─ Staff table ─ */
  .sp-table-wrap { overflow-x: auto; border-radius: 14px; border: 1px solid rgba(255,255,255,.06); }
  .sp-table { width: 100%; border-collapse: collapse; min-width: 600px; }
  .sp-table thead tr { background: linear-gradient(90deg, #1a1400, #0d0d0e); border-bottom: 1px solid rgba(255,215,0,.1); }
  .sp-table thead th { padding: .9rem 1.25rem; font-size: .65rem; font-weight: 700; letter-spacing: .1em; text-transform: uppercase; color: #555560; text-align: left; white-space: nowrap; }
  .sp-table tbody tr { border-bottom: 1px solid rgba(255,255,255,.04); transition: background .12s; }
  .sp-table tbody tr:last-child { border-bottom: none; }
  .sp-table tbody tr:hover { background: rgba(255,215,0,.02); }
  .sp-table td { padding: .95rem 1.25rem; font-size: .84rem; color: #9A9AA5; vertical-align: middle; }

  .sp-role-pill { display: inline-flex; align-items: center; border-radius: 20px; padding: 3px 10px; font-size: .65rem; font-weight: 700; text-transform: uppercase; letter-spacing: .05em; }
  .sp-role-pill.moderator   { background: rgba(139,92,246,.12); color: #a78bfa; border: 1px solid rgba(139,92,246,.25); }
  .sp-role-pill.maintenance { background: rgba(59,130,246,.12); color: #60a5fa; border: 1px solid rgba(59,130,246,.25); }
  .sp-role-pill.support     { background: rgba(34,197,94,.12); color: #4ade80; border: 1px solid rgba(34,197,94,.25); }
  .sp-role-pill.finance     { background: rgba(251,191,36,.12); color: #fbbf24; border: 1px solid rgba(251,191,36,.25); }
  .sp-role-pill.analytics   { background: rgba(244,63,94,.12); color: #fb7185; border: 1px solid rgba(244,63,94,.25); }

  .sp-active-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; }
  .sp-active-dot.on  { background: #22c55e; box-shadow: 0 0 6px rgba(34,197,94,.5); }
  .sp-active-dot.off { background: #444; }

  .sp-action-btn { padding: 5px 12px; border-radius: 7px; font-size: .76rem; font-weight: 700; font-family: 'DM Sans', sans-serif; cursor: pointer; border: 1px solid; transition: all .15s; }
  .sp-action-btn.toggle-on  { background: rgba(239,68,68,.08); border-color: rgba(239,68,68,.25); color: #f87171; }
  .sp-action-btn.toggle-off { background: rgba(34,197,94,.08); border-color: rgba(34,197,94,.25); color: #4ade80; }
  .sp-action-btn.del        { background: rgba(239,68,68,.08); border-color: rgba(239,68,68,.2); color: #f87171; margin-left: 6px; }
  .sp-action-btn:hover { opacity: .8; }

  /* ─ Add staff modal ─ */
  .sp-modal-bg  { position: fixed; inset: 0; background: rgba(0,0,0,.78); z-index: 900; }
  .sp-modal     { position: fixed; top: 50%; left: 50%; transform: translate(-50%,-50%); width: min(480px, 95vw); background: #16161a; border: 1px solid rgba(255,255,255,.1); border-radius: 18px; z-index: 901; overflow: hidden; box-shadow: 0 32px 80px rgba(0,0,0,.7); }
  .sp-modal-head { padding: 1.1rem 1.5rem; border-bottom: 1px solid rgba(255,255,255,.06); display: flex; align-items: center; justify-content: space-between; background: linear-gradient(90deg, rgba(255,215,0,.05), transparent); }
  .sp-modal-title { font-family: 'Playfair Display', serif; font-weight: 800; font-size: .95rem; color: #ECECEC; }
  .sp-modal-close { background: none; border: none; color: #555; cursor: pointer; font-size: 1.1rem; line-height: 1; }
  .sp-modal-body  { padding: 1.25rem 1.5rem; display: flex; flex-direction: column; gap: 1rem; }
  .sp-modal-foot  { padding: .875rem 1.5rem; border-top: 1px solid rgba(255,255,255,.06); display: flex; justify-content: flex-end; gap: 10px; }
  .sp-btn-cancel  { padding: .6rem 1.1rem; background: rgba(255,255,255,.04); border: 1px solid rgba(255,255,255,.1); border-radius: 9px; color: #9A9AA5; font-family: 'DM Sans', sans-serif; font-size: .84rem; font-weight: 600; cursor: pointer; }

  .sp-field-error { font-size: .72rem; color: #f87171; margin-top: 2px; }

  .sp-pw-note { font-size: .72rem; color: #555560; margin-top: 3px; }
  
  .sp-empty { text-align: center; padding: 3rem; color: #555560; font-size: .88rem; }
  
  .sp-spinner { display: flex; justify-content: center; padding: 2.5rem; }
  
  .sp-add-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem; }
`;

const ROLE_OPTIONS = [
  { value: "moderator",   label: "Moderator" },
  { value: "maintenance", label: "Maintenance" },
  { value: "support",     label: "Support" },
  { value: "finance",     label: "Finance" },
  { value: "analytics",  label: "Analytics" },
];

export default function SettingsPage({ adminRole }) {
  const isSuperadmin = adminRole === "superadmin";

  const [tab, setTab] = useState("platform");

  // ─── Platform settings state ───────────────────────────────
  const [settings, setSettings]     = useState(null);
  const [savingSettings, setSaving] = useState(false);
  const [settingsMsg, setSettingsMsg] = useState(null);

  // ─── Staff state ───────────────────────────────────────────
  const [staff, setStaff]           = useState([]);
  const [staffLoading, setStaffLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newStaff, setNewStaff]     = useState({ name: "", email: "", role: "moderator", password: "" });
  const [addErrors, setAddErrors]   = useState({});
  const [addMsg, setAddMsg]         = useState(null);
  const [savingStaff, setSavingStaff] = useState(false);

  // ─── Password change state ──────────────────────────────────
  const [pw, setPw]                 = useState({ old_password: "", new_password: "" });
  const [pwMsg, setPwMsg]           = useState(null);
  const [savingPw, setSavingPw]     = useState(false);
  const [pwErrors, setPwErrors]     = useState({});

  useEffect(() => {
    fetchSettings();
    if (isSuperadmin) fetchStaff();
  }, [isSuperadmin]);

  const fetchSettings = async () => {
    try {
      const { data } = await api.get("admin/settings/");
      setSettings(data);
    } catch {}
  };

  const fetchStaff = async () => {
    setStaffLoading(true);
    try {
      const { data } = await api.get("admin/staff/");
      setStaff(Array.isArray(data) ? data : []);
    } catch {} finally {
      setStaffLoading(false);
    }
  };

  const saveSettings = async () => {
    setSaving(true);
    setSettingsMsg(null);
    try {
      await api.post("admin/settings/", settings);
      setSettingsMsg({ type: "ok", text: "Settings saved." });
    } catch (e) {
      setSettingsMsg({ type: "err", text: e.response?.data?.error || "Failed to save settings." });
    } finally {
      setSaving(false);
      setTimeout(() => setSettingsMsg(null), 4000);
    }
  };

  const handleAddStaff = async () => {
    setSavingStaff(true);
    setAddErrors({});
    setAddMsg(null);
    try {
      const { data } = await api.post("admin/staff/", newStaff);
      setStaff(prev => [data, ...prev]);
      setShowAddModal(false);
      setNewStaff({ name: "", email: "", role: "moderator", password: "" });
      setAddMsg({ type: "ok", text: `${data.name} added as ${data.role}.` });
      setTimeout(() => setAddMsg(null), 4000);
    } catch (e) {
      const errs = e.response?.data?.errors || {};
      if (Object.keys(errs).length) {
        setAddErrors(errs);
      } else {
        setAddErrors({ _general: e.response?.data?.error || "Failed to add staff member." });
      }
    } finally {
      setSavingStaff(false);
    }
  };

  const toggleStaff = async (id, currentActive) => {
    try {
      const { data } = await api.patch(`admin/staff/${id}/toggle/`);
      setStaff(prev => prev.map(s => s.id === id ? { ...s, active: data.active } : s));
    } catch (e) {
      alert(e.response?.data?.error || "Action failed.");
    }
  };

  const deleteStaff = async (id, name) => {
    if (!window.confirm(`Remove ${name} from staff? This cannot be undone.`)) return;
    try {
      await api.delete(`admin/staff/${id}/`);
      setStaff(prev => prev.filter(s => s.id !== id));
    } catch (e) {
      alert(e.response?.data?.error || "Delete failed.");
    }
  };

  const savePassword = async () => {
    setSavingPw(true);
    setPwMsg(null);
    setPwErrors({});
    try {
      await api.post("admin/change-password/", pw);
      setPwMsg({ type: "ok", text: "Password changed. Please sign in again next session." });
      setPw({ old_password: "", new_password: "" });
      setTimeout(() => setPwMsg(null), 5000);
    } catch (e) {
      const errs = e.response?.data?.errors || {};
      if (Object.keys(errs).length) {
        setPwErrors(errs);
      } else {
        setPwMsg({ type: "err", text: e.response?.data?.error || "Failed to change password." });
      }
    } finally {
      setSavingPw(false);
    }
  };

  // ─── Tabs ──────────────────────────────────────────────────
  const TABS = [
    { key: "platform", label: "Platform" },
    ...(isSuperadmin ? [{ key: "staff", label: "Staff" }] : []),
    { key: "security", label: "Security" },
  ];

  return (
    <div className="sp">
      <style>{S}</style>

      {/* ── Tabs ── */}
      <div className="sp-tabs">
        {TABS.map(t => (
          <button key={t.key} className={`sp-tab${tab === t.key ? " on" : ""}`} onClick={() => setTab(t.key)}>
            {t.label}
          </button>
        ))}
      </div>

      {/* ════════════════════════════════════════
          PLATFORM SETTINGS
      ════════════════════════════════════════ */}
      {tab === "platform" && (
        <>
          {settingsMsg && <div className={`sp-toast ${settingsMsg.type}`}>{settingsMsg.text}</div>}

          {!settings ? (
            <div className="sp-spinner">
              <div className="spinner-border" style={{ color: "#FFD700", width: "1.75rem", height: "1.75rem" }} role="status"/>
            </div>
          ) : (
            <>
              {/* Financials */}
              <div className="sp-card">
                <div className="sp-section-title">Financial Configuration</div>
                <div className="sp-grid">
                  <div className="sp-field">
                    <label className="sp-label">Commission %</label>
                    <input
                      className="sp-input" type="number" min="0" max="100" step="0.5"
                      value={settings.commission_pct || ""}
                      onChange={e => setSettings({ ...settings, commission_pct: e.target.value })}
                    />
                  </div>
                  <div className="sp-field">
                    <label className="sp-label">Min Budget (KES)</label>
                    <input
                      className="sp-input" type="number" min="0"
                      value={settings.min_budget || ""}
                      onChange={e => setSettings({ ...settings, min_budget: e.target.value })}
                    />
                  </div>
                  <div className="sp-field">
                    <label className="sp-label">Max Budget (KES)</label>
                    <input
                      className="sp-input" type="number" min="0"
                      value={settings.max_budget || ""}
                      onChange={e => setSettings({ ...settings, max_budget: e.target.value })}
                    />
                  </div>
                  <div className="sp-field">
                    <label className="sp-label">M-Pesa Shortcode</label>
                    <input
                      className="sp-input" type="text"
                      value={settings.mpesa_shortcode || ""}
                      onChange={e => setSettings({ ...settings, mpesa_shortcode: e.target.value })}
                    />
                  </div>
                </div>
              </div>

              {/* Services */}
              <div className="sp-card">
                <div className="sp-section-title">Enabled Services</div>
                <div className="sp-field">
                  <label className="sp-label">Services (comma-separated)</label>
                  <input
                    className="sp-input" type="text"
                    placeholder="Plumbing, Electrical, Masonry..."
                    value={Array.isArray(settings.enabled_services) ? settings.enabled_services.join(", ") : (settings.enabled_services || "")}
                    onChange={e => setSettings({ ...settings, enabled_services: e.target.value.split(",").map(s => s.trim()).filter(Boolean) })}
                  />
                </div>
              </div>

              {/* Locations */}
              <div className="sp-card">
                <div className="sp-section-title">Enabled Locations</div>
                <div className="sp-field">
                  <label className="sp-label">Locations (comma-separated)</label>
                  <input
                    className="sp-input" type="text"
                    placeholder="Nairobi, Mombasa, Kisumu..."
                    value={Array.isArray(settings.enabled_locations) ? settings.enabled_locations.join(", ") : (settings.enabled_locations || "")}
                    onChange={e => setSettings({ ...settings, enabled_locations: e.target.value.split(",").map(s => s.trim()).filter(Boolean) })}
                  />
                </div>
              </div>

              <div className="sp-save-row">
                <button className="sp-btn-save" onClick={saveSettings} disabled={savingSettings}>
                  {savingSettings ? "Saving..." : "Save Settings"}
                </button>
              </div>
            </>
          )}
        </>
      )}

      {/* ════════════════════════════════════════
          STAFF MANAGEMENT
      ════════════════════════════════════════ */}
      {tab === "staff" && isSuperadmin && (
        <>
          {addMsg && <div className={`sp-toast ${addMsg.type}`}>{addMsg.text}</div>}

          <div className="sp-add-row">
            <div className="sp-section-title" style={{ margin: 0 }}>Staff Members</div>
            <button className="sp-btn-save" onClick={() => { setShowAddModal(true); setAddErrors({}); setAddMsg(null); }}>
              Add Staff Member
            </button>
          </div>

          <div className="sp-table-wrap">
            {staffLoading ? (
              <div className="sp-spinner">
                <div className="spinner-border" style={{ color: "#FFD700", width: "1.75rem", height: "1.75rem" }} role="status"/>
              </div>
            ) : staff.length === 0 ? (
              <div className="sp-empty">No staff members yet. Add one above.</div>
            ) : (
              <table className="sp-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Status</th>
                    <th>Joined</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {staff.map(s => (
                    <tr key={s.id}>
                      <td style={{ color: "#ECECEC", fontWeight: 600 }}>{s.name}</td>
                      <td>{s.email}</td>
                      <td>
                        <span className={`sp-role-pill ${s.role}`}>
                          {s.role}
                        </span>
                      </td>
                      <td>
                        <span className="sp-active-dot" style={{ marginRight: 6 }}
                          classname={s.active ? "on" : "off"}
                          css={undefined}
                        >
                          <span
                            className={`sp-active-dot ${s.active ? "on" : "off"}`}
                            style={{ marginRight: 0 }}
                          />
                        </span>
                        <span style={{ fontSize: ".78rem", color: s.active ? "#22c55e" : "#555560" }}>
                          {s.active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>{s.joined || "—"}</td>
                      <td>
                        <button
                          className={`sp-action-btn ${s.active ? "toggle-on" : "toggle-off"}`}
                          onClick={() => toggleStaff(s.id, s.active)}
                        >
                          {s.active ? "Deactivate" : "Activate"}
                        </button>
                        <button
                          className="sp-action-btn del"
                          onClick={() => deleteStaff(s.id, s.name)}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* Add Staff Modal */}
          {showAddModal && (
            <>
              <div className="sp-modal-bg" onClick={() => setShowAddModal(false)} />
              <div className="sp-modal">
                <div className="sp-modal-head">
                  <span className="sp-modal-title">Add Staff Member</span>
                  <button className="sp-modal-close" onClick={() => setShowAddModal(false)}>✕</button>
                </div>
                <div className="sp-modal-body">
                  {addErrors._general && <div className="sp-toast err">{addErrors._general}</div>}

                  {[
                    { label: "Full Name", key: "name", type: "text", placeholder: "Jane Kamau" },
                    { label: "Email Address", key: "email", type: "email", placeholder: "jane@kaakazini.com" },
                    { label: "Password", key: "password", type: "password", placeholder: "Min. 8 characters" },
                  ].map(({ label, key, type, placeholder }) => (
                    <div className="sp-field" key={key}>
                      <label className="sp-label">{label}</label>
                      <input
                        className="sp-input" type={type} placeholder={placeholder}
                        value={newStaff[key]}
                        onChange={e => setNewStaff({ ...newStaff, [key]: e.target.value })}
                      />
                      {addErrors[key] && <span className="sp-field-error">{addErrors[key]}</span>}
                      {key === "password" && <span className="sp-pw-note">A welcome email with these credentials will be sent.</span>}
                    </div>
                  ))}

                  <div className="sp-field">
                    <label className="sp-label">Role</label>
                    <select
                      className="sp-input"
                      value={newStaff.role}
                      onChange={e => setNewStaff({ ...newStaff, role: e.target.value })}
                    >
                      {ROLE_OPTIONS.map(r => (
                        <option key={r.value} value={r.value}>{r.label}</option>
                      ))}
                    </select>
                    {addErrors.role && <span className="sp-field-error">{addErrors.role}</span>}
                  </div>
                </div>
                <div className="sp-modal-foot">
                  <button className="sp-btn-cancel" onClick={() => setShowAddModal(false)}>Cancel</button>
                  <button className="sp-btn-save" onClick={handleAddStaff} disabled={savingStaff}>
                    {savingStaff ? "Adding..." : "Add Staff Member"}
                  </button>
                </div>
              </div>
            </>
          )}
        </>
      )}

      {/* ════════════════════════════════════════
          SECURITY (change password)
      ════════════════════════════════════════ */}
      {tab === "security" && (
        <>
          {pwMsg && <div className={`sp-toast ${pwMsg.type}`}>{pwMsg.text}</div>}
          <div className="sp-card" style={{ maxWidth: 440 }}>
            <div className="sp-section-title">Change Password</div>
            {[
              { label: "Current Password", key: "old_password" },
              { label: "New Password",     key: "new_password" },
            ].map(({ label, key }) => (
              <div className="sp-field" style={{ marginBottom: "1rem" }} key={key}>
                <label className="sp-label">{label}</label>
                <input
                  className="sp-input" type="password"
                  placeholder={key === "new_password" ? "Min. 8 characters" : ""}
                  value={pw[key]}
                  onChange={e => setPw({ ...pw, [key]: e.target.value })}
                />
                {pwErrors[key] && <span className="sp-field-error">{pwErrors[key]}</span>}
              </div>
            ))}
            <div className="sp-save-row">
              <button className="sp-btn-save" onClick={savePassword} disabled={savingPw}>
                {savingPw ? "Saving..." : "Change Password"}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}